import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PublicShell } from "@/app/PublicShell";
import "./i18n";
import "@fontsource/plus-jakarta-sans/latin-400.css";
import "@fontsource/plus-jakarta-sans/latin-500.css";
import "@fontsource/plus-jakarta-sans/latin-600.css";
import "@fontsource/plus-jakarta-sans/latin-700.css";
import "@fontsource/bricolage-grotesque/latin-700.css";
import "@fontsource/poppins/latin-700.css";
import "./index.css";
import { startPwa } from "@/lib/pwa";

startPwa();

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <PublicShell />
    </StrictMode>
);
